import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

type Props = {
  isOpen: boolean,
  onContinueInviting: () => void,
  onClose: () => void,
}

const InviteUserWarningModal = ({ isOpen, onContinueInviting, onClose } : Props) => {
  return (
    <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title="You've exceeded your seat limit" onClose={onClose} />
      <ModalBody>
          🎊 Great that more of your colleagues want to join inSided! By inviting a new user, you went over your current seat limit. That’s no problem - you can still continue. We'll reach out to discuss adjusting your limit, and won’t charge you anything without your consent.
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Continue inviting' variant='primary' onClick={onContinueInviting} class='qa-continue-invite-user' />
        <ButtonControl title='Cancel' onClick={() => onClose()} />
      </ModalFooter>
    </Modal>
  )
}

export default InviteUserWarningModal
